import ISetting from "@/interfaces/setting";

export default class Setting implements ISetting {
  constructor(data: { id: any; key: any; value: any }) {
    this.setData(data);
  }

  setData(data: { id: any; key: any; value: any }) {
    const { id, key, value } = data;
    if (id) {
      this.id = id;
    }

    if (key) {
      this.key = key;
    }

    if (value) {
      if (value === "true") {
        this.value = true;
      } else if (value === "false") {
        this.value = false;
      } else {
        this.value = value;
      }
    }
  }

  id = "";
  key = "";
  value: string | boolean = "";
}
